import { useTranslation } from 'react-i18next';

import { SectionField } from '@/components/SectionField/SectionField';
import { useDcrContext } from '@/features/DataChangeRequest/_context/DcrContext';
import { FilteredField } from '@/features/DataChangeRequest/FilteredField/FilteredField';
import { HcoSection } from '@/pages/MyDCRsPage/ViewDCRModal/_hooks/useHcoFieldNames';
import { HcpSection } from '@/pages/MyDCRsPage/ViewDCRModal/_hooks/useHcpFieldNames';

type Props = {
	label: string;
	value: number | string | null | undefined;
	name: string;
	filterable?: boolean;
	section: HcoSection | HcpSection;
};

export const FormReadOnlyField = ({
	label,
	value: v,
	name,
	filterable = true,
	section
}: Props) => {
	const { t } = useTranslation();
	const { unavailableFields } = useDcrContext();

	if (name) {
		const parts = name.split('.');
		const leafName = parts[parts.length - 1];

		const isUnavailable = leafName && unavailableFields?.includes(leafName);

		if (isUnavailable) {
			return null;
		}
	}

	const value =
		typeof v === 'number' || (typeof v === 'string' && v.length > 0) ? v : '-';

	return (
		<FilteredField name={name} section={section} enabled={filterable}>
			<SectionField
				label={t(label)}
				value={value.toString()}
				labelWidth={200}
				hideLabel={label === ''}
				collapseAt='sm'
			/>
		</FilteredField>
	);
};
